import React from 'react';
import styled from 'styled-components';
import { HorizontalList } from '../../../../shared/components/List';
import { spaces, media } from '../../../../shared/lib/styles';
import NavHeadingLink from './NavHeadingLink';

const NavigationList = styled.nav`
    margin-right: ${spaces.space8}px;

    @media ${media('small')} {
        display: none;
    }
`;

const StyledNavigation = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;

    @media ${media('small')} {
        padding: 0 ${spaces.halfGutter}px;
    }
`;

interface Props {
    categoryKey: string;
    currentSection: string;
    children: React.ReactNode;
}

const Navigation = ({ categoryKey, currentSection, children }: Props) => {
    const navLinks = [
        { title: __('How it works'), href: '#how-it-works', key: 'how-it-works', scrollOffset: 75 },
        { title: __('What you get'), href: '#details', key: 'details', scrollOffset: 100 },
        { title: __('Reviews'), href: '#reviews', key: 'reviews', scrollOffset: 75 },
        { title: __('FAQs'), href: '#faq', key: 'faq', scrollOffset: 75 },
    ];

    return (
        <StyledNavigation>
            <NavigationList>
                <HorizontalList
                    items={navLinks.map((link, index) => (
                        <NavHeadingLink
                            key={index}
                            link={link}
                            categoryKey={categoryKey}
                            isActive={currentSection === link.key}
                        />
                    ))}
                />
            </NavigationList>
            {children}
        </StyledNavigation>
    );
};

export default Navigation;
